module.exports = __webpack_public_path__ + "static/media/PressStart2P-Regular.2c404fd0.ttf";